import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { SITE } from "../constants/site";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMsg)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-20 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] border border-white/30 flex items-center justify-center hover:bg-[#1EB85A] hover:scale-105 transition-[background-color,transform] shadow-[0_8px_30px_rgba(18,32,49,0.25)]"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      <MessageCircle size={24} className="relative text-white" strokeWidth={1.5} />
    </motion.a>
  );
}
